import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { reveal, container } from "../lib/motion";
import { useLead } from "../context/LeadContext";

export const FinalCTA = () => {
  const { openLead } = useLead();
  return (
    <section className="relative overflow-hidden bg-mist py-28 md:py-40">
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="h-[300px] w-[300px] rounded-full bg-teal/10 blur-[120px] md:h-[500px] md:w-[500px]" />
      </div>
      <motion.div
        variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-100px" }}
        className="relative mx-auto max-w-4xl px-5 text-center md:px-10"
      >
        <motion.span variants={reveal} className="mb-6 inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-teal">
          Let's Work Together
        </motion.span>
        <motion.h2 variants={reveal} className="font-display text-4xl font-semibold leading-[0.95] tracking-tighter text-ink md:text-7xl" data-testid="final-cta-headline">
          Ready to Build a Marketing Presence That Works?
        </motion.h2>
        <motion.p variants={reveal} className="mx-auto mt-6 max-w-xl font-sans text-lg leading-relaxed text-zinc-600">
          Let's create a clear, professional, and consistent marketing system for your business.
        </motion.p>
        <motion.button
          variants={reveal} onClick={() => openLead("consultation")} data-testid="final-cta-button"
          className="group mx-auto mt-10 flex items-center gap-3 bg-teal px-9 py-5 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-ink"
        >
          Book a Consultation <ArrowRight weight="bold" className="transition-transform group-hover:translate-x-1" />
        </motion.button>
      </motion.div>
    </section>
  );
};
